export function getMonthNamesForLocale(locale: string) {
  const baseDate = new Date(Date.UTC(2012, 0, 2)); // just a Monday
  const monthNames = [...Array(12).keys()].map((monthIndex) => {
    baseDate.setMonth(monthIndex);
    return new Intl.DateTimeFormat(locale, { month: "long" }).format(baseDate);
  });
  return monthNames;
}
